// @owners { team: patients-team }
import { useQuery } from '@tanstack/react-query';
import { getCurrentUserID } from '~shared/features/users/selectors/getUsers';
import { staleTimes } from '~shared/queries/constants';
import { queries } from '~shared/queries/query-keys';
import { useSelectorShared } from '~shared/store';

export const useQueryInstructionalVideos = () => {
  const patientID = useSelectorShared(getCurrentUserID);
  const { isFetching, isSuccess, data, isError } = useQuery({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ...queries.instructionalVideos.fetchAll({ patient_id: patientID! }),
    enabled: !!patientID,
    staleTime: staleTimes.fifteenMinutes,
  });

  return {
    isFetching,
    isSuccess,
    isError,
    videos: data?.data,
  };
};
